import { cn } from '@/lib/utils'
import { CategoriaEnum } from '@acme/auth'
import Divider from '@mui/material/Divider'
import { useAuth } from 'hooks'
import { Calendar1Icon, CalendarIcon } from 'lucide-react'
import { useState } from 'react'
import { useDigitacaoContext } from './pages/useDigitacaoContext'

export type ViewMode = 'diario' | 'mensal'

export function useDigitacaoView() {
    const [view, setView] = useState<ViewMode>('mensal')
    return [view, setView] as const
}

export default function DigitacaoView() {
    const {
        decoded: { categoria },
    } = useAuth()
    const { view, changeView } = useDigitacaoContext()

    if (
        ![
            CategoriaEnum.Cliente,
            CategoriaEnum.Supervisor,
            CategoriaEnum.Avaliacao,
        ].includes(categoria)
    )
        return null

    return [
        <Divider key="divider" orientation="vertical" flexItem />,
        <div
            key="radio"
            data-slot="radio-group"
            className={cn(
                'grid grid-cols-2 gap-0',
                '*:flex *:items-center *:gap-1 *:p-2',
                '*:hover:bg-primary/20 *:cursor-pointer',
                '*:border *:border-muted-foreground/50',
                '*:transition-all *:duration-200',
            )}
        >
            <div
                className={cn('rounded-l-sm', {
                    'border-0 ring-1 ring-primary': view === 'diario',
                })}
                onClick={() => changeView('diario')}
            >
                <Calendar1Icon
                    className={cn({ 'text-primary': view === 'diario' })}
                />
                <span>Diário</span>
            </div>
            <div
                className={cn('rounded-r-sm', {
                    'border-0 ring-1 ring-primary': view === 'mensal',
                })}
                onClick={() => changeView('mensal')}
            >
                <CalendarIcon
                    className={cn({ 'text-primary': view === 'mensal' })}
                />
                <span>Mensal</span>
            </div>
        </div>,
    ]
}
